// extracted by mini-css-extract-plugin
export default {"statBlock":"StatBlock_statBlock__maPp2","statNumber":"StatBlock_statNumber__OWOxI","statDescription":"StatBlock_statDescription__MpgIe"};